import { WalletNotConnectedError } from '@solana/wallet-adapter-base';
import { useWallet, useAnchorWallet } from '@solana/wallet-adapter-react';
import { Program, Provider } from '@project-serum/anchor';

import { clusterApiUrl, Connection, PublicKey, SystemProgram } from '@solana/web3.js';
import React, { FC } from 'react';
import messageService, { MessagesInfo} from "./Messages";
import idl from './idl.json';
import {  getProgram, GLOBAL_ACCOUNT } from "./utils";
const anchor = require("@project-serum/anchor");


const programID = new PublicKey(idl.metadata.address);

const Form: FC = () => {
    const { publicKey } = useWallet();
    const wallet = useAnchorWallet();
    const connection = new Connection(clusterApiUrl('mainnet-beta'),'confirmed');
    const [message, setMessage] = React.useState("");

    const [messagesInfo, setMessagesInfo] = React.useState<MessagesInfo | undefined>(undefined);
    // @ts-ignore
    const [program, setProgram] = React.useState<Program>(undefined);
    // @ts-ignore
    const [provider, setProvider] = React.useState<Provider>(undefined);
    const [loading, setLoading] = React.useState(true);

    const refreshData = async () => {
      if (!wallet || !publicKey) throw new WalletNotConnectedError();
      const messagesInfo = await messageService.reportMessagesAndPage(program, publicKey);
      setMessagesInfo(messagesInfo);
      setLoading(false);
    }



    React.useEffect(() => {
      const loadData = async () => {
        if (!wallet || !publicKey ) throw new WalletNotConnectedError();
        // @ts-ignore
        const program = getProgram(wallet, connection);
        const provider = program.provider;
  
        const messagesInfo = await messageService.reportMessagesAndPage(program, publicKey);
        setMessagesInfo(messagesInfo);
  
        setProgram(program);
        setProvider(provider);
        setLoading(false);
      }
      loadData();
    }, []);


    async function glob(): Promise<void> {
      // @ts-ignore
      const program = new Program(idl, programID, provider);
      if (provider){
      try {
        const globalAccount = anchor.web3.Keypair.generate();
        console.log(globalAccount.publicKey.toString());
        await program.rpc.initializeGlobal({
          accounts: {
            globalAccount: globalAccount.publicKey,
            user: provider.wallet.publicKey,
            systemProgram: SystemProgram.programId,
          },
          signers: [globalAccount]
        });
        await refreshData();
      } catch (err) {
        console.log("Transaction error: ", err);
      }
      }
    }

    async function hello(): Promise<void> {
      // @ts-ignore
      const program = new Program(idl, programID, provider);
      if (provider){
      try {
        const pageKeypair = await messageService.getMessagesKeypair(provider.wallet.publicKey, programID);
        console.log(provider.connection);
        console.log(provider.wallet.publicKey.toString());
        await program.rpc.initialize(provider.wallet.publicKey, {
          accounts: {
            baseAccount: pageKeypair.publicKey,
            user: provider.wallet.publicKey,
            systemProgram: SystemProgram.programId,
          },
          signers: [pageKeypair]
        });
        await refreshData();
        const account = await program.account.baseAccount.fetch(pageKeypair.publicKey);
        console.log('page account: ', account);
        await refreshData();
        // setIsInit(true);
      } catch (err) {
        console.log("Transaction error: ", err);
      }
      }
    }

    async function update() {
      if (!messagesInfo ||  !messagesInfo.pageKey) {
        console.log("unable to find page! aborting")
        return;
      }
      try {
      await program.rpc.update(message, {
        accounts: {
          baseAccount: messagesInfo.pageKey,
          globalAccount: GLOBAL_ACCOUNT,
          authority: provider.wallet.publicKey,
        }
      });

      await refreshData();
    }
     catch (err) {
      console.log("Transaction error: ", err);
     }

    }

    async function newPage() {
      if (!messagesInfo || !messagesInfo.pageKey){
        throw new Error("Missing messages info");
      }
      const newPageKeypair = await messageService.getMessagesKeypair(provider.wallet.publicKey, messagesInfo.pageKey);
      await program.rpc.nextPage(newPageKeypair.publicKey, provider.wallet.publicKey, {
        accounts: {
          nextBaseAccount: newPageKeypair.publicKey,
          baseAccount: messagesInfo.pageKey,
          authority: provider.wallet.publicKey,
          systemProgram: SystemProgram.programId,
        },
        signers: [newPageKeypair]
      });
      const account = await program.account.baseAccount.fetch(newPageKeypair.publicKey);
      console.log('page account: ', account);
      await refreshData();

    }
 
    return (
        <div className="Form">
          <header className="Form-header">
            {/* <p>{!messagesInfo ||  !messagesInfo.pageKey ? "message account not initialized" : messagesInfo.pageKey.toString()}</p> */}
            <p>{!publicKey ? "Loading ..." : ""}</p>
          </header>
          {/* <button onClick={glob} disabled={!publicKey}>
            Glob
          </button>  */}
          {!messagesInfo || !messagesInfo.pageKey ? 
          <button onClick={hello} disabled={!publicKey}>
            Initialize Account
          </button> : messagesInfo.pageFull ?
          <div> Out of storage space on message account. Please create more storage <br></br>
          <button onClick={newPage} disabled={!publicKey}>
            Create More Storage
          </button>
            
          </div> : 
          <div>
          <textarea
          // type="text"
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="What's on your mind?"
          />
          <br />
          <button onClick={update} disabled={false}>
            post new message
          </button> </div> }
          {(!loading && publicKey && program) ? ""
           : "Loading"}
        </div>
    );

};

export default Form;
